
import axios from '@/store/config';
import { findIndex } from 'lodash'
import dayjs from 'dayjs'

export default {
  // state
  state : {
    subscriptions: []
  },
  // getters
  getters : {
    subscriptions: state => {
      return state.subscriptions; //_.map(state.subscriptions, mapObjects.subscriptionToSearchFilters);
    }
  },

  // actions
  actions : {

    /**
     * Hämta alla bevakningar på inloggad användare
     */
    fetchSubscriptions ({ commit }) {
      let now = dayjs().valueOf();
      return axios.get('/applicants/me/subscriptions?excludeDisabled=true')
      .then((response) => {
        const data = response.data.map((subscription) => {

          /**
           * waitingListType finns inte på bevakningar idags läget
           * men jag har byggt in stöd för det i clienten.
           *
           * Så, finns den inte på svaret från servern måste den läggas på
           */
          if(subscription.waitingListType === undefined)
            subscription.waitingListType = [];

          return subscription
        })

        const filteredData = data.filter((subscription) => {

          let endDate = dayjs(subscription.waitingListPeriodTo).valueOf();
          if(endDate < now) return false;

          return true
        })
        commit('setSubscriptions', filteredData);
      }).catch((error) => {
          if (axios.isCancel(error) || error.code === 'ECONNABORTED') {
            console.warn('Subscriptions request aborted');
            return;
          }
          console.error('Subscriptions request failed:', error);
          throw error; 
        });
    },

    /**
     * Hämta enskild subscription på code
     */
    fetchSingleSubscriptionByCode ({ commit, rootState }, code) {
      return new Promise((resolve, reject) => {
        axios.get('/subscriptions/'+code)
        .then((response) => {
          const subscription = response.data;

          /**
           * waitingListType finns inte på bevakningar idags läget
           * men jag har byggt in stöd för det i clienten.
           *
           * Så, finns den inte på svaret från servern måste den läggas på
           */
          if(subscription.waitingListType === undefined)
            subscription.waitingListType = [];

          resolve(subscription);
          commit('pushSubscriptions', subscription)
        }).catch(reject)
      })
    },

    /**
     * Skapa bevakning på användaren. Bevakningen ingår sedan i samlingen av bevakningar.
     *
     * @param {*} payload
     */
    createSubscription({ dispatch, state, commit}, payload){
      return new Promise((resolve, reject) =>{
        axios.post('/applicants/me/subscriptions/' + payload.type, payload.subscription)
        .then((response) => {
          dispatch('fetchSubscriptions').then((response) => {
            resolve();
          })
        }).catch((error) => {
          reject(error);
        })

      });
    },

    /**
     * Uppdatera bevakning.
     * Den uppdaterade bevakningen ingår sedan i samlingen av bevakningar.
     */
    updateSubscription ({ dispatch, state, commit }, subscription) {
      subscription.administrativeUnitAreas = (subscription.administrativeUnitAreas.length) ? subscription.administrativeUnitAreas : subscription.administrativeUnitTownDistricts;
      subscription.administrativeUnitTownDistricts = [];
      subscription.disable = !subscription.enabled;
      return new Promise((resolve, reject) => {
        axios.put('/subscriptions/'+subscription.code, subscription)
        .then(() => {
          commit('pushSubscriptions', subscription);
          resolve(subscription);
        }).catch(reject)
      })
    },

    /**
     * Förläng bevakning.
     */
    extendSubscription ({ dispatch, state, commit }, subscription) {
      return new Promise((resolve, reject) => {
        //extend 90 days
//        axios.put('/subscriptions/'+subscription.code, { "numberOfDays"  :  90 })
        axios.put('/subscriptions/'+subscription.code, subscription, { "numberOfDays"  :  90 })
          .then(() => {
            var newDate = new Date(subscription.waitingListPeriodTo);
            newDate.setDate(newDate.getDate() + 90);
            subscription.waitingListPeriodTo = newDate;

            commit('pushSubscriptions', subscription);
            resolve(subscription);
          }).catch(reject)
      })
    },

    /**
     * Aktiverar bevakning.
     * TODO: Ta bort hårdkodad enabled = true när (om) vi får uppdaterat svar från servern.
     */
    activateSubscription ({ dispatch, state, commit }, code) {
      return new Promise((resolve, reject) => {
        axios.put('/subscriptions/'+code +'/enable')
        .then(() => {
          return this.dispatch('fetchSingleSubscriptionByCode', code).then(subscription => {
            //TODO: subscription.enabled bör komma från servern egent. Men när svaret kommer är den inte uppdaterad på servern än.
            subscription.enabled = true;
            resolve(subscription);
          })
        }).catch(reject)
      })

    },

    /**
     * Inaktiverar bevakning.
     * TODO: Ta bort hårdkodad enabled = false när (om) vi får uppdaterat svar från servern.
     */
    dectivateSubscription ({ dispatch, state, commit }, code) {
      return new Promise((resolve, reject) => {
        axios.put('/subscriptions/'+code +'/disable')
        .then(() => {
          return this.dispatch('fetchSingleSubscriptionByCode', code).then(subscription => {
            //TODO: subscription.enabled bör komma från servern egent. Men när svaret kommer är den inte uppdaterad på servern än.
            subscription.enabled = false;
            resolve(subscription);
          })
        }).catch(reject)
      })

    },

    /**
     * Ta bort angiven bevakning
     */
    deleteSubscription ({ dispatch, state, commit }, code) {
      return axios.delete('/subscriptions/'+code)
      .then(() => {
        commit('deleteSubscription', code);
      });
    }
  },

  // mutations
  mutations : {
    setSubscriptions (state, subscriptions) {
      state.subscriptions = subscriptions;
    },
    deleteSubscription (state, code) {
      state.subscriptions.splice(findIndex(state.subscriptions, (sub) => {
        return sub.code == code;
      }), 1);
    },

    /**
     * Ersätter en uppdaterad subscription i arrayen av subscriptions
     */
    pushSubscriptions(state, data){
      state.subscriptions = [
        ...state.subscriptions.filter(n => n.code != data.code),
        data
      ]
    },
    setShow (state, index) {
      state.isShow[index] = !state.isShow[index];
    }

  }
}
